import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";

export const usePageLayout = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const noFooterRoutes = [
      ROUTES.TICKETS,
      ROUTES.LOGIN,
      ROUTES.REGISTER,
      ROUTES.RESET_PASSWORD,
    ];

    const noNavBarRoutes = [ROUTES.TICKETS];

    const showFooter = !noFooterRoutes.some((route) =>
      pathname.startsWith(route),
    );
    const showNavBar = !noNavBarRoutes.some((route) =>
      pathname.startsWith(route),
    );

    return {
      showFooter,
      showNavBar,
    };
  }, [pathname]);
};
